import React from 'react'
import { Autocomplete, CircularProgress, TextField } from '@mui/material'

const AutoCompleteComponent = ({
    name,
    label,
    options,
    loading,
    handleChangeAutoComplete,
    inputRef,
    index,
    handleSearchValueAutoComplete
}) => {
    

    return (
        <Autocomplete
           // style={{ width:"96%" }}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            options={options}
            loading={loading}
            onInputChange={(e,v) => handleSearchValueAutoComplete(v,index)}
            getOptionLabel={(options) => options  ? options.EnglishText+`${options?.Address ? ' ('+options.Address+')' : '' }`+`${options.DataType ? ' - ('+options.DataType+')' : '' }` : ''}
            renderInput={(params) => (
                <TextField 
                    margin='dense'
                    name={name}
                    inputRef={inputRef}
                    {...params} 
                    label={label} 
                    variant="outlined"
                    InputProps={{
                        ...params.InputProps,
                        endAdornment: (
                            <>
                                {loading ? <CircularProgress color='primary' size={20} /> : null}
                                {params.InputProps.endAdornment}
                            </>
                        )
                        
                    }}
                />
            )}
            onChange={(e,value)  => handleChangeAutoComplete(value, index)}
        />
    ) 
}

export default AutoCompleteComponent